import Chip from '@components/v2/ui/Chip/Chip';
import { Box, SxProps, Theme } from '@mui/material';
import { alpha } from '@mui/material/styles';
import LangEnum from '../../../../../../lang/LangEnum';
import { BusinessPolicyAstLogicalOperator } from '../../../../../../services/modules/business-policies/businessPolicyCondition.types';
import { BusinessPoliciesTestIds } from '../../../../../../utils/testIds/businessPolicies.testIds';
import { useTranslation } from '../../../../../translation/TranslationContext';

const LABEL_BY_OPERATOR: Partial<Record<BusinessPolicyAstLogicalOperator, LangEnum>> = {
  [BusinessPolicyAstLogicalOperator.AND]: LangEnum.BUSINESS_POLICY_OPERATOR_AND_LABEL,
  [BusinessPolicyAstLogicalOperator.OR]: LangEnum.BUSINESS_POLICY_OPERATOR_OR_LABEL,
};

const TEST_ID_BY_OPERATOR: Partial<
  Record<BusinessPolicyAstLogicalOperator, BusinessPoliciesTestIds>
> = {
  [BusinessPolicyAstLogicalOperator.AND]: BusinessPoliciesTestIds.FORM_CRITERIA_AND_CONNECTOR,
  [BusinessPolicyAstLogicalOperator.OR]: BusinessPoliciesTestIds.FORM_CRITERIA_OR_CONNECTOR,
};

const getConnectorSx =
  (backgroundOpacity: number): SxProps<Theme> =>
  (theme) => {
    const backgroundColor = alpha(theme.palette.primary.main, backgroundOpacity);
    return {
      backgroundColor,
      color: theme.palette.primary.contrastText,
      '&:hover': { backgroundColor },
    };
  };

const SX_BY_OPERATOR: Partial<Record<BusinessPolicyAstLogicalOperator, SxProps<Theme>>> = {
  [BusinessPolicyAstLogicalOperator.AND]: getConnectorSx(0.88),
  [BusinessPolicyAstLogicalOperator.OR]: getConnectorSx(1),
};

interface BusinessPolicyCriteriaConnectorProps {
  operator: BusinessPolicyAstLogicalOperator;
}

const BusinessPolicyCriteriaConnector = ({ operator }: BusinessPolicyCriteriaConnectorProps) => {
  const { translate } = useTranslation();
  const label = LABEL_BY_OPERATOR[operator];

  if (!label) {
    return null;
  }

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
      <Chip
        size="small"
        label={translate(label)}
        sx={SX_BY_OPERATOR[operator]}
        testId={TEST_ID_BY_OPERATOR[operator]}
      />
    </Box>
  );
};

export default BusinessPolicyCriteriaConnector;
